/* eslint-disable no-undef */
/* eslint-disable import/no-webpack-loader-syntax */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// proposal card translations
import daYaml from 'js-yaml-loader!../../../translations/affiliate/portfolio/messages.da.yaml';
import deYaml from 'js-yaml-loader!../../../translations/affiliate/portfolio/messages.de.yaml';
import enYaml from 'js-yaml-loader!../../../translations/affiliate/portfolio/messages.en.yaml';
import esYaml from 'js-yaml-loader!../../../translations/affiliate/portfolio/messages.es.yaml';
import frYaml from 'js-yaml-loader!../../../translations/affiliate/portfolio/messages.fr.yaml';
import nlYaml from 'js-yaml-loader!../../../translations/affiliate/portfolio/messages.nl.yaml';
import plYaml from 'js-yaml-loader!../../../translations/affiliate/portfolio/messages.pl.yaml';
import zhYaml from 'js-yaml-loader!../../../translations/affiliate/portfolio/messages.zh.yaml';
import zhHKYaml from 'js-yaml-loader!../../../translations/affiliate/portfolio/messages.zh_HK.yaml';

// investor card translations
import invDaYaml from 'js-yaml-loader!../../../translations/macros/investor-card/messages.da.yaml';
import invDeYaml from 'js-yaml-loader!../../../translations/macros/investor-card/messages.de.yaml';
import invEnYaml from 'js-yaml-loader!../../../translations/macros/investor-card/messages.en.yaml';
import invEsYaml from 'js-yaml-loader!../../../translations/macros/investor-card/messages.es.yaml';
import invFrYaml from 'js-yaml-loader!../../../translations/macros/investor-card/messages.fr.yaml';
import invNlYaml from 'js-yaml-loader!../../../translations/macros/investor-card/messages.nl.yaml';
import invPlYaml from 'js-yaml-loader!../../../translations/macros/investor-card/messages.pl.yaml';
import invZhYaml from 'js-yaml-loader!../../../translations/macros/investor-card/messages.zh.yaml';
import invZhHKYaml from 'js-yaml-loader!../../../translations/macros/investor-card/messages.zh_HK.yaml';

// inbox translations
import inboxDaYaml from 'js-yaml-loader!../../../translations/auth/inbox/messages.da.yaml';
import inboxDeYaml from 'js-yaml-loader!../../../translations/auth/inbox/messages.de.yaml';
import inboxEnYaml from 'js-yaml-loader!../../../translations/auth/inbox/messages.en.yaml';
import inboxEsYaml from 'js-yaml-loader!../../../translations/auth/inbox/messages.es.yaml';
import inboxFrYaml from 'js-yaml-loader!../../../translations/auth/inbox/messages.fr.yaml';
import inboxNlYaml from 'js-yaml-loader!../../../translations/auth/inbox/messages.nl.yaml';
import inboxPlYaml from 'js-yaml-loader!../../../translations/auth/inbox/messages.pl.yaml';
import inboxZhYaml from 'js-yaml-loader!../../../translations/auth/inbox/messages.zh.yaml';
import inboxZhHKYaml from 'js-yaml-loader!../../../translations/auth/inbox/messages.zh_HK.yaml';

import cancellationSurveyDaYaml from 'js-yaml-loader!../../../translations/subscription/cancellation-survey/messages.da.yaml';
import cancellationSurveyDeYaml from 'js-yaml-loader!../../../translations/subscription/cancellation-survey/messages.de.yaml';
import cancellationSurveyEnYaml from 'js-yaml-loader!../../../translations/subscription/cancellation-survey/messages.en.yaml';
import cancellationSurveyEsYaml from 'js-yaml-loader!../../../translations/subscription/cancellation-survey/messages.es.yaml';
import cancellationSurveyFrYaml from 'js-yaml-loader!../../../translations/subscription/cancellation-survey/messages.fr.yaml';
import cancellationSurveyNlYaml from 'js-yaml-loader!../../../translations/subscription/cancellation-survey/messages.nl.yaml';
import cancellationSurveyPlYaml from 'js-yaml-loader!../../../translations/subscription/cancellation-survey/messages.pl.yaml';
import cancellationSurveyZhYaml from 'js-yaml-loader!../../../translations/subscription/cancellation-survey/messages.zh.yaml';
import cancellationSurveyZhHKYaml from 'js-yaml-loader!../../../translations/subscription/cancellation-survey/messages.zh_HK.yaml';

// my investors translations
import myInvDaYaml from 'js-yaml-loader!../../../translations/entrepreneur/my-investors/messages.da.yaml';
import myInvDeYaml from 'js-yaml-loader!../../../translations/entrepreneur/my-investors/messages.de.yaml';
import myInvEnYaml from 'js-yaml-loader!../../../translations/entrepreneur/my-investors/messages.en.yaml';
import myInvEsYaml from 'js-yaml-loader!../../../translations/entrepreneur/my-investors/messages.es.yaml';
import myInvFrYaml from 'js-yaml-loader!../../../translations/entrepreneur/my-investors/messages.fr.yaml';
import myInvNlYaml from 'js-yaml-loader!../../../translations/entrepreneur/my-investors/messages.nl.yaml';
import myInvPlYaml from 'js-yaml-loader!../../../translations/entrepreneur/my-investors/messages.pl.yaml';
import myInvZhYaml from 'js-yaml-loader!../../../translations/entrepreneur/my-investors/messages.zh.yaml';
import myInvZhHKYaml from 'js-yaml-loader!../../../translations/entrepreneur/my-investors/messages.zh_HK.yaml';

// my list translations
import myListDaYaml from 'js-yaml-loader!../../../translations/investor/my-list/messages.da.yaml';
import myListDeYaml from 'js-yaml-loader!../../../translations/investor/my-list/messages.de.yaml';
import myListEnYaml from 'js-yaml-loader!../../../translations/investor/my-list/messages.en.yaml';
import myListEsYaml from 'js-yaml-loader!../../../translations/investor/my-list/messages.es.yaml';
import myListFrYaml from 'js-yaml-loader!../../../translations/investor/my-list/messages.fr.yaml';
import myListNlYaml from 'js-yaml-loader!../../../translations/investor/my-list/messages.nl.yaml';
import myListPlYaml from 'js-yaml-loader!../../../translations/investor/my-list/messages.pl.yaml';
import myListZhYaml from 'js-yaml-loader!../../../translations/investor/my-list/messages.zh.yaml';
import myListZhHKYaml from 'js-yaml-loader!../../../translations/investor/my-list/messages.zh_HK.yaml';

// find investors translations
import findInvDaYaml from 'js-yaml-loader!../../../translations/entrepreneur/find-investors/messages.da.yaml';
import findInvDeYaml from 'js-yaml-loader!../../../translations/entrepreneur/find-investors/messages.de.yaml';
import findInvEnYaml from 'js-yaml-loader!../../../translations/entrepreneur/find-investors/messages.en.yaml';
import findInvEsYaml from 'js-yaml-loader!../../../translations/entrepreneur/find-investors/messages.es.yaml';
import findInvFrYaml from 'js-yaml-loader!../../../translations/entrepreneur/find-investors/messages.fr.yaml';
import findInvNlYaml from 'js-yaml-loader!../../../translations/entrepreneur/find-investors/messages.nl.yaml';
import findInvPlYaml from 'js-yaml-loader!../../../translations/entrepreneur/find-investors/messages.pl.yaml';
import findInvZhYaml from 'js-yaml-loader!../../../translations/entrepreneur/find-investors/messages.zh.yaml';
import findInvZhHKYaml from 'js-yaml-loader!../../../translations/entrepreneur/find-investors/messages.zh_HK.yaml';

// business proposal translations
import businessProposalDaYaml from 'js-yaml-loader!../../../translations/proposal/business-proposal/messages.da.yaml';
import businessProposalDeYaml from 'js-yaml-loader!../../../translations/proposal/business-proposal/messages.de.yaml';
import businessProposalEnYaml from 'js-yaml-loader!../../../translations/proposal/business-proposal/messages.en.yaml';
import businessProposalEsYaml from 'js-yaml-loader!../../../translations/proposal/business-proposal/messages.es.yaml';
import businessProposalFrYaml from 'js-yaml-loader!../../../translations/proposal/business-proposal/messages.fr.yaml';
import businessProposalNlYaml from 'js-yaml-loader!../../../translations/proposal/business-proposal/messages.nl.yaml';
import businessProposalPlYaml from 'js-yaml-loader!../../../translations/proposal/business-proposal/messages.pl.yaml';
import businessProposalZhYaml from 'js-yaml-loader!../../../translations/proposal/business-proposal/messages.zh.yaml';
import businessProposalZhHKYaml from 'js-yaml-loader!../../../translations/proposal/business-proposal/messages.zh_HK.yaml';

import commonLocationsDaYaml from 'js-yaml-loader!../../../translations/common/locations/messages.da.yaml';
import commonLocationsDeYaml from 'js-yaml-loader!../../../translations/common/locations/messages.de.yaml';
import commonLocationsEnYaml from 'js-yaml-loader!../../../translations/common/locations/messages.en.yaml';
import commonLocationsEsYaml from 'js-yaml-loader!../../../translations/common/locations/messages.es.yaml';
import commonLocationsFrYaml from 'js-yaml-loader!../../../translations/common/locations/messages.fr.yaml';
import commonLocationsNlYaml from 'js-yaml-loader!../../../translations/common/locations/messages.nl.yaml';
import commonLocationsPlYaml from 'js-yaml-loader!../../../translations/common/locations/messages.pl.yaml';
import commonLocationsZhYaml from 'js-yaml-loader!../../../translations/common/locations/messages.zh.yaml';
import commonLocationsZhHKYaml from 'js-yaml-loader!../../../translations/common/locations/messages.zh_HK.yaml';

// nudge modal translations
import nudgeDaYaml from 'js-yaml-loader!../../../translations/macros/nudge/messages.da.yaml';
import nudgeDeYaml from 'js-yaml-loader!../../../translations/macros/nudge/messages.de.yaml';
import nudgeEnYaml from 'js-yaml-loader!../../../translations/macros/nudge/messages.en.yaml';
import nudgeEsYaml from 'js-yaml-loader!../../../translations/macros/nudge/messages.es.yaml';
import nudgeFrYaml from 'js-yaml-loader!../../../translations/macros/nudge/messages.fr.yaml';
import nudgeNlYaml from 'js-yaml-loader!../../../translations/macros/nudge/messages.nl.yaml';
import nudgePlYaml from 'js-yaml-loader!../../../translations/macros/nudge/messages.pl.yaml';
import nudgeZhYaml from 'js-yaml-loader!../../../translations/macros/nudge/messages.zh.yaml';
import nudgeZhHKYaml from 'js-yaml-loader!../../../translations/macros/nudge/messages.zh_HK.yaml';

// investor prompt translations
import invPromptDaYaml from 'js-yaml-loader!../../../translations/investor/search/messages.da.yaml';
import invPromptDeYaml from 'js-yaml-loader!../../../translations/investor/search/messages.de.yaml';
import invPromptEnYaml from 'js-yaml-loader!../../../translations/investor/search/messages.en.yaml';
import invPromptEsYaml from 'js-yaml-loader!../../../translations/investor/search/messages.es.yaml';
import invPromptFrYaml from 'js-yaml-loader!../../../translations/investor/search/messages.fr.yaml';
import invPromptNlYaml from 'js-yaml-loader!../../../translations/investor/search/messages.nl.yaml';
import invPromptPlYaml from 'js-yaml-loader!../../../translations/investor/search/messages.pl.yaml';
import invPromptZhYaml from 'js-yaml-loader!../../../translations/investor/search/messages.zh.yaml';
import invPromptZhHKYaml from 'js-yaml-loader!../../../translations/investor/search/messages.zh_HK.yaml';

// investor dashboard translations
import investorDashboardDaYaml from 'js-yaml-loader!../../../translations/investor/dashboard/messages.da.yaml';
import investorDashboardDeYaml from 'js-yaml-loader!../../../translations/investor/dashboard/messages.de.yaml';
import investorDashboardEnYaml from 'js-yaml-loader!../../../translations/investor/dashboard/messages.en.yaml';
import investorDashboardEsYaml from 'js-yaml-loader!../../../translations/investor/dashboard/messages.es.yaml';
import investorDashboardFrYaml from 'js-yaml-loader!../../../translations/investor/dashboard/messages.fr.yaml';
import investorDashboardNlYaml from 'js-yaml-loader!../../../translations/investor/dashboard/messages.nl.yaml';
import investorDashboardPlYaml from 'js-yaml-loader!../../../translations/investor/dashboard/messages.pl.yaml';
import investorDashboardZhYaml from 'js-yaml-loader!../../../translations/investor/dashboard/messages.zh.yaml';
import investorDashboardZhHKYaml from 'js-yaml-loader!../../../translations/investor/dashboard/messages.zh_HK.yaml';

// investor dashboard translations
import entrepreneurDashboardDaYaml from 'js-yaml-loader!../../../translations/entrepreneur/dashboard/messages.da.yaml';
import entrepreneurDashboardDeYaml from 'js-yaml-loader!../../../translations/entrepreneur/dashboard/messages.de.yaml';
import entrepreneurDashboardEnYaml from 'js-yaml-loader!../../../translations/entrepreneur/dashboard/messages.en.yaml';
import entrepreneurDashboardEsYaml from 'js-yaml-loader!../../../translations/entrepreneur/dashboard/messages.es.yaml';
import entrepreneurDashboardFrYaml from 'js-yaml-loader!../../../translations/entrepreneur/dashboard/messages.fr.yaml';
import entrepreneurDashboardNlYaml from 'js-yaml-loader!../../../translations/entrepreneur/dashboard/messages.nl.yaml';
import entrepreneurDashboardPlYaml from 'js-yaml-loader!../../../translations/entrepreneur/dashboard/messages.pl.yaml';
import entrepreneurDashboardZhYaml from 'js-yaml-loader!../../../translations/entrepreneur/dashboard/messages.zh.yaml';
import entrepreneurDashboardZhHKYaml from 'js-yaml-loader!../../../translations/entrepreneur/dashboard/messages.zh_HK.yaml';

// newsfeed translations
import newsfeedDaYaml from 'js-yaml-loader!../../../translations/newsfeed/messages.da.yaml';
import newsfeedDeYaml from 'js-yaml-loader!../../../translations/newsfeed/messages.de.yaml';
import newsfeedEnYaml from 'js-yaml-loader!../../../translations/newsfeed/messages.en.yaml';
import newsfeedEsYaml from 'js-yaml-loader!../../../translations/newsfeed/messages.es.yaml';
import newsfeedFrYaml from 'js-yaml-loader!../../../translations/newsfeed/messages.fr.yaml';
import newsfeedNlYaml from 'js-yaml-loader!../../../translations/newsfeed/messages.nl.yaml';
import newsfeedPlYaml from 'js-yaml-loader!../../../translations/newsfeed/messages.pl.yaml';
import newsfeedZhYaml from 'js-yaml-loader!../../../translations/newsfeed/messages.zh.yaml';
import newsfeedZhHKYaml from 'js-yaml-loader!../../../translations/newsfeed/messages.zh_HK.yaml';

// staff picks translations
import staffPicksDaYaml from 'js-yaml-loader!../../../translations/proposal/staff-picks/messages.da.yaml';
import staffPicksDeYaml from 'js-yaml-loader!../../../translations/proposal/staff-picks/messages.de.yaml';
import staffPicksEnYaml from 'js-yaml-loader!../../../translations/proposal/staff-picks/messages.en.yaml';
import staffPicksEsYaml from 'js-yaml-loader!../../../translations/proposal/staff-picks/messages.es.yaml';
import staffPicksFrYaml from 'js-yaml-loader!../../../translations/proposal/staff-picks/messages.fr.yaml';
import staffPicksNlYaml from 'js-yaml-loader!../../../translations/proposal/staff-picks/messages.nl.yaml';
import staffPicksPlYaml from 'js-yaml-loader!../../../translations/proposal/staff-picks/messages.pl.yaml';
import staffPicksZhYaml from 'js-yaml-loader!../../../translations/proposal/staff-picks/messages.zh.yaml';
import staffPicksZhHKYaml from 'js-yaml-loader!../../../translations/proposal/staff-picks/messages.zh_HK.yaml';

// toast translations
import toastDaYaml from 'js-yaml-loader!../../../translations/common/toast/messages.da.yaml';
import toastDeYaml from 'js-yaml-loader!../../../translations/common/toast/messages.de.yaml';
import toastEnYaml from 'js-yaml-loader!../../../translations/common/toast/messages.en.yaml';
import toastEsYaml from 'js-yaml-loader!../../../translations/common/toast/messages.es.yaml';
import toastFrYaml from 'js-yaml-loader!../../../translations/common/toast/messages.fr.yaml';
import toastNlYaml from 'js-yaml-loader!../../../translations/common/toast/messages.nl.yaml';
import toastPlYaml from 'js-yaml-loader!../../../translations/common/toast/messages.pl.yaml';
import toastZhYaml from 'js-yaml-loader!../../../translations/common/toast/messages.zh.yaml';
import toastZhHKYaml from 'js-yaml-loader!../../../translations/common/toast/messages.zh_HK.yaml';

// explore page translations
import exploreDaYaml from 'js-yaml-loader!../../../translations/explore/messages.da.yaml';
import exploreDeYaml from 'js-yaml-loader!../../../translations/explore/messages.de.yaml';
import exploreEnYaml from 'js-yaml-loader!../../../translations/explore/messages.en.yaml';
import exploreEsYaml from 'js-yaml-loader!../../../translations/explore/messages.es.yaml';
import exploreFrYaml from 'js-yaml-loader!../../../translations/explore/messages.fr.yaml';
import exploreNlYaml from 'js-yaml-loader!../../../translations/explore/messages.nl.yaml';
import explorePlYaml from 'js-yaml-loader!../../../translations/explore/messages.pl.yaml';
import exploreZhYaml from 'js-yaml-loader!../../../translations/explore/messages.zh.yaml';
import exploreZhHKYaml from 'js-yaml-loader!../../../translations/explore/messages.zh_HK.yaml';

// homepage translations
import homepageDaYaml from 'js-yaml-loader!../../../translations/homepage/messages.da.yaml';
import homepageDeYaml from 'js-yaml-loader!../../../translations/homepage/messages.de.yaml';
import homepageEnYaml from 'js-yaml-loader!../../../translations/homepage/messages.en.yaml';
import homepageEsYaml from 'js-yaml-loader!../../../translations/homepage/messages.es.yaml';
import homepageFrYaml from 'js-yaml-loader!../../../translations/homepage/messages.fr.yaml';
import homepageNlYaml from 'js-yaml-loader!../../../translations/homepage/messages.nl.yaml';
import homepagePlYaml from 'js-yaml-loader!../../../translations/homepage/messages.pl.yaml';
import homepageZhYaml from 'js-yaml-loader!../../../translations/homepage/messages.zh.yaml';
import homepageZhHKYaml from 'js-yaml-loader!../../../translations/homepage/messages.zh_HK.yaml';

// notification page translations
import notificationDaYaml from 'js-yaml-loader!../../../translations/notification/messages.da.yaml';
import notificationDeYaml from 'js-yaml-loader!../../../translations/notification/messages.de.yaml';
import notificationEnYaml from 'js-yaml-loader!../../../translations/notification/messages.en.yaml';
import notificationEsYaml from 'js-yaml-loader!../../../translations/notification/messages.es.yaml';
import notificationFrYaml from 'js-yaml-loader!../../../translations/notification/messages.fr.yaml';
import notificationNlYaml from 'js-yaml-loader!../../../translations/notification/messages.nl.yaml';
import notificationPlYaml from 'js-yaml-loader!../../../translations/notification/messages.pl.yaml';
import notificationZhYaml from 'js-yaml-loader!../../../translations/notification/messages.zh.yaml';
import notificationZhHKYaml from 'js-yaml-loader!../../../translations/notification/messages.zh_HK.yaml';

import testimonialsDaYaml from 'js-yaml-loader!../../../translations/content/testimonials/messages.da.yaml';
import testimonialsDeYaml from 'js-yaml-loader!../../../translations/content/testimonials/messages.de.yaml';
import testimonialsEnYaml from 'js-yaml-loader!../../../translations/content/testimonials/messages.en.yaml';
import testimonialsEsYaml from 'js-yaml-loader!../../../translations/content/testimonials/messages.es.yaml';
import testimonialsFrYaml from 'js-yaml-loader!../../../translations/content/testimonials/messages.fr.yaml';
import testimonialsNlYaml from 'js-yaml-loader!../../../translations/content/testimonials/messages.nl.yaml';
import testimonialsPlYaml from 'js-yaml-loader!../../../translations/content/testimonials/messages.pl.yaml';
import testimonialsZhYaml from 'js-yaml-loader!../../../translations/content/testimonials/messages.zh.yaml';
import testimonialsZhHKYaml from 'js-yaml-loader!../../../translations/content/testimonials/messages.zh_HK.yaml';

// my matches translations
import myMatchesDaYaml from 'js-yaml-loader!../../../translations/investor/my-matches/messages.da.yaml';
import myMatchesDeYaml from 'js-yaml-loader!../../../translations/investor/my-matches/messages.de.yaml';
import myMatchesEnYaml from 'js-yaml-loader!../../../translations/investor/my-matches/messages.en.yaml';
import myMatchesEsYaml from 'js-yaml-loader!../../../translations/investor/my-matches/messages.es.yaml';
import myMatchesFrYaml from 'js-yaml-loader!../../../translations/investor/my-matches/messages.fr.yaml';
import myMatchesNlYaml from 'js-yaml-loader!../../../translations/investor/my-matches/messages.nl.yaml';
import myMatchesPlYaml from 'js-yaml-loader!../../../translations/investor/my-matches/messages.pl.yaml';
import myMatchesZhYaml from 'js-yaml-loader!../../../translations/investor/my-matches/messages.zh.yaml';
import myMatchesZhHKYaml from 'js-yaml-loader!../../../translations/investor/my-matches/messages.zh_HK.yaml';

// my-pitches translations
import myPitchesDaYaml from 'js-yaml-loader!../../../translations/entrepreneur/my-pitches/messages.da.yaml';
import myPitchesDeYaml from 'js-yaml-loader!../../../translations/entrepreneur/my-pitches/messages.de.yaml';
import myPitchesEnYaml from 'js-yaml-loader!../../../translations/entrepreneur/my-pitches/messages.en.yaml';
import myPitchesEsYaml from 'js-yaml-loader!../../../translations/entrepreneur/my-pitches/messages.es.yaml';
import myPitchesFrYaml from 'js-yaml-loader!../../../translations/entrepreneur/my-pitches/messages.fr.yaml';
import myPitchesNlYaml from 'js-yaml-loader!../../../translations/entrepreneur/my-pitches/messages.nl.yaml';
import myPitchesPlYaml from 'js-yaml-loader!../../../translations/entrepreneur/my-pitches/messages.pl.yaml';
import myPitchesZhYaml from 'js-yaml-loader!../../../translations/entrepreneur/my-pitches/messages.zh.yaml';
import myPitchesZhHKYaml from 'js-yaml-loader!../../../translations/entrepreneur/my-pitches/messages.zh_HK.yaml';

// proposal detail translations
import proposalDetailDaYaml from 'js-yaml-loader!../../../translations/proposal/proposal-detail/messages.da.yaml';
import proposalDetailDeYaml from 'js-yaml-loader!../../../translations/proposal/proposal-detail/messages.de.yaml';
import proposalDetailEnYaml from 'js-yaml-loader!../../../translations/proposal/proposal-detail/messages.en.yaml';
import proposalDetailEsYaml from 'js-yaml-loader!../../../translations/proposal/proposal-detail/messages.es.yaml';
import proposalDetailFrYaml from 'js-yaml-loader!../../../translations/proposal/proposal-detail/messages.fr.yaml';
import proposalDetailNlYaml from 'js-yaml-loader!../../../translations/proposal/proposal-detail/messages.nl.yaml';
import proposalDetailPlYaml from 'js-yaml-loader!../../../translations/proposal/proposal-detail/messages.pl.yaml';
import proposalDetailZhYaml from 'js-yaml-loader!../../../translations/proposal/proposal-detail/messages.zh.yaml';
import proposalDetailZhHKYaml from 'js-yaml-loader!../../../translations/proposal/proposal-detail/messages.zh_HK.yaml';

// proposal dashboard translations
import proposalDashboardDaYaml from 'js-yaml-loader!../../../translations/proposal/dashboard/messages.da.yaml';
import proposalDashboardDeYaml from 'js-yaml-loader!../../../translations/proposal/dashboard/messages.de.yaml';
import proposalDashboardEnYaml from 'js-yaml-loader!../../../translations/proposal/dashboard/messages.en.yaml';
import proposalDashboardEsYaml from 'js-yaml-loader!../../../translations/proposal/dashboard/messages.es.yaml';
import proposalDashboardFrYaml from 'js-yaml-loader!../../../translations/proposal/dashboard/messages.fr.yaml';
import proposalDashboardNlYaml from 'js-yaml-loader!../../../translations/proposal/dashboard/messages.nl.yaml';
import proposalDashboardPlYaml from 'js-yaml-loader!../../../translations/proposal/dashboard/messages.pl.yaml';
import proposalDashboardZhYaml from 'js-yaml-loader!../../../translations/proposal/dashboard/messages.zh.yaml';
import proposalDashboardZhHKYaml from 'js-yaml-loader!../../../translations/proposal/dashboard/messages.zh_HK.yaml';

// pitch creation translations
import pitchCreationEnYaml from 'js-yaml-loader!../../../translations/proposal/pitch-creation/messages.en.yaml';
import pitchCreationDeYaml from 'js-yaml-loader!../../../translations/proposal/pitch-creation/messages.de.yaml';
import pitchCreationEsYaml from 'js-yaml-loader!../../../translations/proposal/pitch-creation/messages.es.yaml';
import pitchCreationFrYaml from 'js-yaml-loader!../../../translations/proposal/pitch-creation/messages.fr.yaml';
import pitchCreationNlYaml from 'js-yaml-loader!../../../translations/proposal/pitch-creation/messages.nl.yaml';
import pitchCreationPlYaml from 'js-yaml-loader!../../../translations/proposal/pitch-creation/messages.pl.yaml';
import pitchCreationZhYaml from 'js-yaml-loader!../../../translations/proposal/pitch-creation/messages.zh.yaml';
import pitchCreationZhHKYaml from 'js-yaml-loader!../../../translations/proposal/pitch-creation/messages.zh_HK.yaml';

// Learn page translations
import learnDaYaml from 'js-yaml-loader!../../../translations/content/learn/messages.da.yaml';
import learnDeYaml from 'js-yaml-loader!../../../translations/content/learn/messages.de.yaml';
import learnEnYaml from 'js-yaml-loader!../../../translations/content/learn/messages.en.yaml';
import learnEsYaml from 'js-yaml-loader!../../../translations/content/learn/messages.es.yaml';
import learnFrYaml from 'js-yaml-loader!../../../translations/content/learn/messages.fr.yaml';
import learnNlYaml from 'js-yaml-loader!../../../translations/content/learn/messages.nl.yaml';
import learnPlYaml from 'js-yaml-loader!../../../translations/content/learn/messages.pl.yaml';
import learnZhYaml from 'js-yaml-loader!../../../translations/content/learn/messages.zh.yaml';
import learnZhHKYaml from 'js-yaml-loader!../../../translations/content/learn/messages.zh_HK.yaml';

// Newsletter Admin translations
import newsletterAdminDaYaml from 'js-yaml-loader!../../../translations/admin/comms/newsletter-templates/messages.da.yaml';
import newsletterAdminDeYaml from 'js-yaml-loader!../../../translations/admin/comms/newsletter-templates/messages.de.yaml';
import newsletterAdminEnYaml from 'js-yaml-loader!../../../translations/admin/comms/newsletter-templates/messages.en.yaml';
import newsletterAdminEsYaml from 'js-yaml-loader!../../../translations/admin/comms/newsletter-templates/messages.es.yaml';
import newsletterAdminFrYaml from 'js-yaml-loader!../../../translations/admin/comms/newsletter-templates/messages.fr.yaml';
import newsletterAdminNlYaml from 'js-yaml-loader!../../../translations/admin/comms/newsletter-templates/messages.nl.yaml';
import newsletterAdminPlYaml from 'js-yaml-loader!../../../translations/admin/comms/newsletter-templates/messages.pl.yaml';
import newsletterAdminZhYaml from 'js-yaml-loader!../../../translations/admin/comms/newsletter-templates/messages.zh.yaml';
import newsletterAdminZhHKYaml from 'js-yaml-loader!../../../translations/admin/comms/newsletter-templates/messages.zh_HK.yaml';

// Translations for FAQs
import affiliateMacroDaYaml from 'js-yaml-loader!../../../translations/affiliate/affiliate-macro/messages.da.yaml';
import affiliateMacroDeYaml from 'js-yaml-loader!../../../translations/affiliate/affiliate-macro/messages.de.yaml';
import affiliateMacroEnYaml from 'js-yaml-loader!../../../translations/affiliate/affiliate-macro/messages.en.yaml';
import affiliateMacroEsYaml from 'js-yaml-loader!../../../translations/affiliate/affiliate-macro/messages.es.yaml';
import affiliateMacroFrYaml from 'js-yaml-loader!../../../translations/affiliate/affiliate-macro/messages.fr.yaml';
import affiliateMacroNlYaml from 'js-yaml-loader!../../../translations/affiliate/affiliate-macro/messages.nl.yaml';
import affiliateMacroPlYaml from 'js-yaml-loader!../../../translations/affiliate/affiliate-macro/messages.pl.yaml';
import affiliateMacroZhYaml from 'js-yaml-loader!../../../translations/affiliate/affiliate-macro/messages.zh.yaml';
import affiliateMacroZhHKYaml from 'js-yaml-loader!../../../translations/affiliate/affiliate-macro/messages.zh_HK.yaml';

// Translations for Connection Messages
import connectionMessagesDeYaml from 'js-yaml-loader!../../../translations/content/connection/messages.de.yaml';
import connectionMessagesEnYaml from 'js-yaml-loader!../../../translations/content/connection/messages.en.yaml';
import connectionMessagesEsYaml from 'js-yaml-loader!../../../translations/content/connection/messages.es.yaml';
import connectionMessagesFrYaml from 'js-yaml-loader!../../../translations/content/connection/messages.fr.yaml';
import connectionMessagesNlYaml from 'js-yaml-loader!../../../translations/content/connection/messages.nl.yaml';
import connectionMessagesPlYaml from 'js-yaml-loader!../../../translations/content/connection/messages.pl.yaml';
import connectionMessagesZhYaml from 'js-yaml-loader!../../../translations/content/connection/messages.zh.yaml';
import connectionMessagesZhHKYaml from 'js-yaml-loader!../../../translations/content/connection/messages.zh_HK.yaml';

// detect lang attribute
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  const currentLang = document.documentElement.lang;

  switch (currentLang) {
    case 'sp':
      document.documentElement.lang = 'es';
      break;
    case 'ge':
      document.documentElement.lang = 'de';
      break;
    case 'nld':
      document.documentElement.lang = 'nl';
      break;
    default:
      document.documentElement.lang = currentLang;
  }
}
const region =
  typeof document !== 'undefined'
    ? document.documentElement.dataset.region
    : '';

// Fixes sentry error in webpack build operation
if (region === 'HK' && document.documentElement.lang === 'zh') {
  document.documentElement.lang = 'zh-HK';
}

const options = {
  // order and from where user language should be detected
  order: ['htmlTag', 'navigator', 'path'],

  // keys or params to lookup language from
  lookupQuerystring: 'lng',
  lookupCookie: 'i18next',
  lookupLocalStorage: 'i18nextLng',
  lookupFromPathIndex: 0,
  lookupFromSubdomainIndex: 0,

  // cache user language on
  caches: ['localStorage', 'cookie']
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    detection: options,
    resources: {
      en: {
        translation: {
          ...enYaml,
          ...invEnYaml,
          ...findInvEnYaml,
          ...commonLocationsEnYaml,
          ...inboxEnYaml,
          ...myInvEnYaml,
          ...businessProposalEnYaml,
          ...myListEnYaml,
          ...nudgeEnYaml,
          ...invPromptEnYaml,
          ...investorDashboardEnYaml,
          ...entrepreneurDashboardEnYaml,
          ...newsfeedEnYaml,
          ...staffPicksEnYaml,
          ...toastEnYaml,
          ...exploreEnYaml,
          ...cancellationSurveyEnYaml,
          ...homepageEnYaml,
          ...notificationEnYaml,
          ...testimonialsEnYaml,
          ...myPitchesEnYaml,
          ...proposalDetailEnYaml,
          ...proposalDashboardEnYaml,
          ...myMatchesEnYaml,
          ...learnEnYaml,
          ...newsletterAdminEnYaml,
          ...affiliateMacroEnYaml,
          ...pitchCreationEnYaml,
          ...connectionMessagesEnYaml,
          currency: '{{val, currency}}'
        }
      },
      fr: {
        translation: {
          ...frYaml,
          ...invFrYaml,
          ...findInvFrYaml,
          ...commonLocationsFrYaml,
          ...inboxFrYaml,
          ...myInvFrYaml,
          ...businessProposalFrYaml,
          ...myListFrYaml,
          ...nudgeFrYaml,
          ...invPromptFrYaml,
          ...investorDashboardFrYaml,
          ...entrepreneurDashboardFrYaml,
          ...newsfeedFrYaml,
          ...staffPicksFrYaml,
          ...toastFrYaml,
          ...exploreFrYaml,
          ...cancellationSurveyFrYaml,
          ...homepageFrYaml,
          ...notificationFrYaml,
          ...testimonialsFrYaml,
          ...myPitchesFrYaml,
          ...proposalDetailFrYaml,
          ...proposalDashboardFrYaml,
          ...myMatchesFrYaml,
          ...learnFrYaml,
          ...newsletterAdminFrYaml,
          ...affiliateMacroFrYaml,
          ...pitchCreationFrYaml,
          ...connectionMessagesFrYaml,
          currency: '{{val, currency}}'
        }
      },
      de: {
        translation: {
          ...deYaml,
          ...invDeYaml,
          ...findInvDeYaml,
          ...commonLocationsDeYaml,
          ...inboxDeYaml,
          ...myInvDeYaml,
          ...businessProposalDeYaml,
          ...myListDeYaml,
          ...nudgeDeYaml,
          ...invPromptDeYaml,
          ...investorDashboardDeYaml,
          ...entrepreneurDashboardDeYaml,
          ...newsfeedDeYaml,
          ...staffPicksDeYaml,
          ...toastDeYaml,
          ...exploreDeYaml,
          ...cancellationSurveyDeYaml,
          ...homepageDeYaml,
          ...notificationDeYaml,
          ...testimonialsDeYaml,
          ...myPitchesDeYaml,
          ...proposalDetailDeYaml,
          ...proposalDashboardDeYaml,
          ...myMatchesDeYaml,
          ...learnDeYaml,
          ...newsletterAdminDeYaml,
          ...affiliateMacroDeYaml,
          ...pitchCreationDeYaml,
          ...connectionMessagesDeYaml,
          currency: '{{val, currency}}'
        }
      },
      es: {
        translation: {
          ...esYaml,
          ...invEsYaml,
          ...findInvEsYaml,
          ...commonLocationsEsYaml,
          ...inboxEsYaml,
          ...myInvEsYaml,
          ...businessProposalEsYaml,
          ...myListEsYaml,
          ...nudgeEsYaml,
          ...invPromptEsYaml,
          ...investorDashboardEsYaml,
          ...entrepreneurDashboardEsYaml,
          ...newsfeedEsYaml,
          ...staffPicksEsYaml,
          ...toastEsYaml,
          ...exploreEsYaml,
          ...cancellationSurveyEsYaml,
          ...homepageEsYaml,
          ...notificationEsYaml,
          ...testimonialsEsYaml,
          ...myPitchesEsYaml,
          ...proposalDetailEsYaml,
          ...proposalDashboardEsYaml,
          ...myMatchesEsYaml,
          ...learnEsYaml,
          ...newsletterAdminEsYaml,
          ...affiliateMacroEsYaml,
          ...pitchCreationEsYaml,
          ...connectionMessagesEsYaml,
          currency: '{{val, currency}}'
        }
      },
      nl: {
        translation: {
          ...nlYaml,
          ...invNlYaml,
          ...findInvNlYaml,
          ...commonLocationsNlYaml,
          ...inboxNlYaml,
          ...myInvNlYaml,
          ...businessProposalNlYaml,
          ...myListNlYaml,
          ...nudgeNlYaml,
          ...invPromptNlYaml,
          ...investorDashboardNlYaml,
          ...entrepreneurDashboardNlYaml,
          ...newsfeedNlYaml,
          ...staffPicksNlYaml,
          ...toastNlYaml,
          ...exploreNlYaml,
          ...cancellationSurveyNlYaml,
          ...homepageNlYaml,
          ...notificationNlYaml,
          ...testimonialsNlYaml,
          ...myPitchesNlYaml,
          ...proposalDetailNlYaml,
          ...proposalDashboardNlYaml,
          ...myMatchesNlYaml,
          ...learnNlYaml,
          ...newsletterAdminNlYaml,
          ...affiliateMacroNlYaml,
          ...pitchCreationNlYaml,
          ...connectionMessagesNlYaml,
          currency: '{{val, currency}}'
        }
      },
      zh: {
        translation: {
          ...zhYaml,
          ...invZhYaml,
          ...findInvZhYaml,
          ...commonLocationsZhYaml,
          ...inboxZhYaml,
          ...myInvZhYaml,
          ...businessProposalZhYaml,
          ...myListZhYaml,
          ...nudgeZhYaml,
          ...invPromptZhYaml,
          ...investorDashboardZhYaml,
          ...entrepreneurDashboardZhYaml,
          ...newsfeedZhYaml,
          ...staffPicksZhYaml,
          ...toastZhYaml,
          ...exploreZhYaml,
          ...cancellationSurveyZhYaml,
          ...homepageZhYaml,
          ...notificationZhYaml,
          ...testimonialsZhYaml,
          ...myPitchesZhYaml,
          ...proposalDetailZhYaml,
          ...proposalDashboardZhYaml,
          ...myMatchesZhYaml,
          ...learnZhYaml,
          ...newsletterAdminZhYaml,
          ...affiliateMacroZhYaml,
          ...pitchCreationZhYaml,
          ...connectionMessagesZhYaml,
          currency: '{{val, currency}}'
        }
      },
      'zh-HK': {
        translation: {
          ...zhHKYaml,
          ...invZhHKYaml,
          ...findInvZhHKYaml,
          ...commonLocationsZhHKYaml,
          ...inboxZhHKYaml,
          ...myInvZhHKYaml,
          ...businessProposalZhHKYaml,
          ...myListZhHKYaml,
          ...nudgeZhHKYaml,
          ...invPromptZhHKYaml,
          ...investorDashboardZhHKYaml,
          ...entrepreneurDashboardZhHKYaml,
          ...newsfeedZhHKYaml,
          ...staffPicksZhHKYaml,
          ...toastZhHKYaml,
          ...exploreZhHKYaml,
          ...cancellationSurveyZhHKYaml,
          ...homepageZhHKYaml,
          ...notificationZhHKYaml,
          ...testimonialsZhHKYaml,
          ...myPitchesZhHKYaml,
          ...proposalDetailZhHKYaml,
          ...proposalDashboardZhHKYaml,
          ...myMatchesZhHKYaml,
          ...learnZhHKYaml,
          ...newsletterAdminZhHKYaml,
          ...affiliateMacroZhHKYaml,
          ...pitchCreationZhHKYaml,
          ...connectionMessagesZhHKYaml,
          currency: '{{val, currency}}'
        }
      },
      pl: {
        translation: {
          ...plYaml,
          ...invPlYaml,
          ...findInvPlYaml,
          ...commonLocationsPlYaml,
          ...inboxPlYaml,
          ...myInvPlYaml,
          ...businessProposalPlYaml,
          ...myListPlYaml,
          ...nudgePlYaml,
          ...invPromptPlYaml,
          ...investorDashboardPlYaml,
          ...entrepreneurDashboardPlYaml,
          ...newsfeedPlYaml,
          ...staffPicksPlYaml,
          ...toastPlYaml,
          ...explorePlYaml,
          ...cancellationSurveyPlYaml,
          ...homepagePlYaml,
          ...notificationPlYaml,
          ...testimonialsPlYaml,
          ...myPitchesPlYaml,
          ...proposalDetailPlYaml,
          ...proposalDashboardPlYaml,
          ...myMatchesPlYaml,
          ...learnPlYaml,
          ...newsletterAdminPlYaml,
          ...affiliateMacroPlYaml,
          ...connectionMessagesPlYaml,
          ...pitchCreationPlYaml,
          currency: '{{val, currency}}'
        }
      },
      da: {
        translation: {
          ...daYaml,
          ...invDaYaml,
          ...findInvDaYaml,
          ...commonLocationsDaYaml,
          ...inboxDaYaml,
          ...myInvDaYaml,
          ...businessProposalDaYaml,
          ...myListDaYaml,
          ...nudgeDaYaml,
          ...invPromptDaYaml,
          ...investorDashboardDaYaml,
          ...entrepreneurDashboardDaYaml,
          ...newsfeedDaYaml,
          ...staffPicksDaYaml,
          ...toastDaYaml,
          ...exploreDaYaml,
          ...cancellationSurveyDaYaml,
          ...homepageDaYaml,
          ...notificationDaYaml,
          ...testimonialsDaYaml,
          ...myPitchesDaYaml,
          ...proposalDetailDaYaml,
          ...proposalDashboardDaYaml,
          ...myMatchesDaYaml,
          ...learnDaYaml,
          ...newsletterAdminDaYaml,
          ...affiliateMacroDaYaml,
          currency: '{{val, currency}}'
        }
      }
    },
    // lng: 'en', // lng: (window && window.locale) || 'en', we can't use window for SSR - need to pass in from twig controller
    fallbackLng: 'en'
  });

export default i18n;
